import GlobalStyle from "../styles/Global.styled";
import Loader from "../components/Loader";
import theme from "../styles/Theme.styled";
import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import MainScreen from "./MainScreen";
import ErrorModal from "../components/ErrorModal/ErrorModal";
import PlaylistModal from "../components/PlaylistModal";
import Toast from "../components/Toast";
import { ErrorProvider } from "../contexts/errorContext";
import { StatusProvider } from "../contexts/statusContext";
import { PlaylistProvider } from "../contexts/playlistContext";

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <ThemeProvider theme={theme}>
      <ErrorProvider>
        <StatusProvider>
          <PlaylistProvider>
            <GlobalStyle />
            <AnimatePresence mode="wait">
              {loading ? (
                <Loader as={motion.div} key="loader" setLoading={setLoading} />
              ) : (
                <>
                  <PlaylistModal />
                  <ErrorModal />
                  <MainScreen />
                  <Toast />
                </>
              )}
            </AnimatePresence>
          </PlaylistProvider>
        </StatusProvider>
      </ErrorProvider>
    </ThemeProvider>
  );
}

export default App;
